import React from 'react';
import { getBrokerName, getBrokerShortName } from '../../config/appConfig';

const BrokerBrand = ({ 
  isDarkMode = false, 
  size = 'default', 
  showIcon = true, 
  showName = true,
  className = '' 
}) => {
  const sizeClasses = {
    small: 'text-sm font-bold',
    default: 'text-base font-bold',
    large: 'text-lg font-bold',
    xl: 'text-xl font-bold'
  };

  const textColor = isDarkMode ? 'text-white' : 'text-gray-900';
  const brokerName = getBrokerName();
  const brokerShortName = getBrokerShortName();
  const hasName = brokerName && brokerName.trim() !== '';
  const hasShortName = brokerShortName && brokerShortName.trim() !== '';

  return (
    <div className={`flex items-center space-x-1.5 ${textColor} ${className}`}>
      {/* Logo Image - show if no name exists or if explicitly requested */}
      {(!hasName || !showName) && (
        <div className="flex items-center justify-center">
          <img 
            src={isDarkMode ? "/images/logo-white.png" : "/images/logo-black.png"} 
            alt="Broker Logo" 
            className="h-12 object-contain"
          />
        </div>
      )}
      
      {/* Short Name Icon - show if short name exists and name also exists */}
      {showIcon && hasShortName && hasName && showName && (
        <div className="flex items-center justify-center w-6 h-6 bg-gradient-to-br from-red-600 to-red-800 rounded-md shadow-lg border border-red-700">
          <span className="text-white font-bold text-xs">{brokerShortName}</span>
        </div>
      )}
      
      {/* Broker Name Text - show if name exists and is requested */}
      {hasName && showName && (
        <div className={sizeClasses[size]}>
          <span className="bg-gradient-to-r from-red-600 to-red-800 bg-clip-text text-transparent">
            {brokerName}
          </span>
        </div>
      )}
    </div>
  );
};

export default BrokerBrand;
